import React from 'react';
import PropTypes from 'prop-types';

import './MiniTechSpecsTable.module.css';

const MiniTechSpecsTable = ({ measurements }) => {
  const measurementData = measurements.map((mData, i) => {
    return (
      <div
        styleName="mini-tech-specs-item"
        key={`${mData.measurement} ${mData.unit}`}
      >
        <div styleName="measurement-input">
          {mData.measurement}
          <span>{mData.unit}</span>
        </div>
        <p styleName="label">{mData.label}</p>
      </div>
    );
  });

  return <div styleName="mini-table">{measurementData}</div>;
};

PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string,
    measurement: PropTypes.string,
    unit: PropTypes.string
  })
);
export default MiniTechSpecsTable;
